/* @ngInject */
const pieceLabels = (
  wagonUtils
) => {
  const self = {}

  self.class = 'pièce'
  self.title = 'Pièces'

  self.fields = {
    name: {
      text: 'Nom',
    },
    quantity: {
      text: 'Quantité',
    },
    sendingDate: {
      text: 'Date d\'expédition',
    },
    sendingPlace: {
      text: 'Lieu d\'expédition',
    },
    weight: {
      text: 'Poids',
    },
  }

  self.statements = {
    number: (_index) => {
      return 'Pièce N°' + _index
    },
    edit: (_myWagonId) => {
      return 'Gestion des pièces de ' + wagonUtils.idToString(_myWagonId)
    },
  }

  self.ask = {
    delete: 'Êtes-vous sûr de vouloir de supprimer cette pièce ?',
  }

  self.log = {
    search: {
      success: (_length = 0) => {
        if (_length === 0) {
          return 'Aucune pièce n\'a été trouvée.'
        } else if (_length === 1) {
          return '1 pièce a été trouvée.'
        } else {
          return _length + ' pièces ont été trouvées.'
        }
      },
      failure: 'Impossible de rechercher les pièces.',
    },
    save: {
      success: 'La pièce a bien été enregistrée.',
      failure: 'Impossible de sauvegarder cet pièce.',
    },
    update: {
      success: 'La pièce a bien été modifiée.',
      failure: 'Impossible de modifier cet pièce.',
    },
    delete: {
      success: 'La pièce a bien été supprimée.',
      failure: 'Impossible de supprimer cet pièce.',
    },
    saveAll: {
      success: (_length = 0) => {
        if (_length === 0) {
          return 'Aucune pièce à sauvegarder.'
        } else if (_length === 1) {
          return 'La pièce a bien été sauvegardée.'
        } else {
          return 'Les ' + _length + ' pièces ont été sauvegardées.'
        }
      },
      failure: 'Impossible de sauvegarder les pièces.',
    },
  }

  return self
}
export default pieceLabels



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/piece/resources/labels.resource.js